import { queryProcedureResult } from 'iguazu-rpc';
import { v4 as uuidv4 } from 'uuid';
import redirect from './redirect';
import {
  APPLICATION_KIND,
  APPLICATION_TYPE,
  READ_BUSINESS_CHECKING_APPLICATION_V1_FUNCTION,
  ROUTES,
} from '../constants';

const onEnterBusinessCheckingDocumentUpload =
  (store) => async (nextState, replace, callback) => {
    const correlationId = uuidv4();
    const state = store.getState();
    const blueprintBaseUrl = state.getIn(['config', 'blueprintBaseUrl']);
    const blueprintErrorUrl = `${blueprintBaseUrl}/account/error`;

    try {
      const urlParams = new URLSearchParams(nextState?.location?.search);
      const pcn = urlParams?.get('pcn');

      if (!pcn) {
        const { promise } = store.dispatch(
          queryProcedureResult({
            procedureName: READ_BUSINESS_CHECKING_APPLICATION_V1_FUNCTION,
            headers: {
              'one-data-correlation-id': correlationId,
            },
            args: {
              body: JSON.stringify({}),
            },
            forceFetch: true,
          })
        );

        const response = await promise;

        if (response instanceof Error) {
          redirect(blueprintErrorUrl, replace);
        }

        if (response?.applications?.length > 0) {
          const bcaAppPcn = response?.applications.find(
            (app) =>
              app?.kind === APPLICATION_KIND.ONBOARDING &&
              app?.type === APPLICATION_TYPE.BUSINESS_CHECKING
          )?.processControlNumber;

          if (bcaAppPcn?.length > 0) {
            const docUrl = `${ROUTES.DOCUMENT_UPLOAD}?pcn=${bcaAppPcn}`;
            redirect(docUrl, replace);
          } else {
            redirect(blueprintErrorUrl, replace);
          }
        }
      }
    } catch (err) {
      redirect(blueprintErrorUrl, replace);
    }

    callback();
  };

export default onEnterBusinessCheckingDocumentUpload;
